<template>
  <div class="support">
    <div class="circle-parent">
      <div class="circle-heading">
        <span class="circle-heading-title">
          <span class="title-main">サポート</span>
          <span class="title-sub">体制</span>
        </span>
      </div>
    </div>

    <div class="support-list">
      <div v-for="(item, index) in items" :key="index" class="support-card">
        <img
          class="support-image"
          v-lazy="item.image"
          :alt="item.text"
        />
        <div class="support-text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          image: '/static/img/support1.webp',
          text: '導入前は設置場所・図面の\n相談からシステム提案が可能',
        },
        {
          image: '/static/img/support2.webp',
          text: 'ご発注から導入まで\n最短１営業日で出荷が可能',
        },
        {
          image: '/static/img/support3.webp',
          text: '導入後のシステムのエラー時は\n電話サポートやWeb会議も可能',
        },
        {
          image: '/static/img/support4.webp',
          text: '故障時には代替機の無償\n貸し出しおよび点検も可能',
        },
      ],
    }
  },
}
</script>

<style scoped>
.support {
  margin: 60px 0 40px;

  text-align: center;
}

.support >>> .circle-heading {
  width: 120px;
  height: 120px;
}

.support >>> .circle-heading-title {
  line-height: 1.2;
}

.support >>> .title-main {
  font-size: 26px;
  display: block;
}

.support >>> .title-sub {
  font-size: 26px;
  display: block;
}

.support-list {
  display: flex;
  justify-content: center;

  max-width: 1400px;
  margin: 80px auto 0;
  padding: 0 20px;
  gap: 24px;
}

@media (max-width: 1099px) {
  .support-list {
    flex-direction: column;
    align-items: center;

    gap: 20px;
  }

  .support-card {
    width: 100%;
    max-width: 320px;
    flex: none;
  }
}

.support-card {
  display: flex;
  flex-direction: column;

  flex: 0 0 255px;
  width: 255px;

  overflow: hidden;

  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: 0 4px 12px rgba(26, 87, 167, 0.12);
}

.support-image {
  display: block;

  width: 100%;
  height: 150px;

  object-fit: cover;
}

.support-text {
  font-size: 14px;
  font-weight: bold;
  line-height: 1.7;

  padding: 18px 14px 22px;

  white-space: pre-line;
  text-align: center;

  color: rgb(26, 87, 167);
  background-color: rgb(233, 245, 255);

  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/Support.vue